<div
  class="min-w-[400px] border-1 bg-white p-5"
  [ngClass]="{
    'text-[#F7FAFDDE]': isDarkMode(),
    'text-standard-text-primary border-standard-outline-light bg-white':
      !isDarkMode(),
  }"
  [ngStyle]="{
    color: corporateDesign.fontColor(),
    borderColor: corporateDesign.primaryBorderColor(),
    backgroundColor: isDarkMode() ? darkModeColor : '',
    borderRadius: corporateDesign.borderRadius(),
  }">
  <ul class="gap- flex flex-col gap-5">
    @for (item of subMenuItems; track $index) {
      @if (!item.isHidden) {
        <li
          tabindex="0"
          awHoverHighlight
          (onHover)="setHighlightedItem($event, $index)"
          class="flex cursor-pointer flex-row items-center gap-3 text-base"
          [ngStyle]="{
            color:
              highlightedItem() === $index
                ? isDarkMode()
                  ? corporateDesignStore.corporateDesign().primaryDarkColor
                  : corporateDesignStore.corporateDesign().primaryColor
                : '',
          }"
          (click)="onSubmenuClick.emit(item.action)"
          (keydown.enter)="onSubmenuClick.emit(item.action)">
          <span class="material-symbols-rounded">{{ item.icon }}</span>
          <span>{{
            textStore.texts()
              | filterTexts: item.translationKey : EEntityType.shoppingCart
              | language
          }}</span>
        </li>
      }
    }
  </ul>
</div>
